module.exports = __webpack_public_path__ + "static/img/69 (2).344317b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/69 (2).jpg
// module id = NLBN
// module chunks = 0